import { createFileRoute } from "@tanstack/react-router";
import { getUserListColors } from "~/components/userListColors";
import { bookmarkListInfiniteQueryOptions } from "~/features/favorites/api";
import { BookmarkListTemplate } from "~/features/favorites/BookmarkListTemplate";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる
const BookmarksPage = () => (
  <div className={`fixed inset-0 z-40 ${getUserListColors().overlayBg}`}>
    <BookmarkListTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/bookmarks")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(bookmarkListInfiniteQueryOptions),
  component: BookmarksPage,
});
